import { render, staticRenderFns } from "./OrderMenu.vue?vue&type=template&id=f6968626&scoped=true&"
import script from "./OrderMenu.vue?vue&type=script&lang=js&"
export * from "./OrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrderMenu.vue?vue&type=style&index=0&id=f6968626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6968626",
  null
  
)

export default component.exports